export const TRANSFER_OUT_FEE = 100;
